import React from "react"
import styled, { css } from "styled-components"

const StyledCard = styled.a`
  color: black;
  margin: 10px 20px;
  display: flex;
  align-items: flex-start;
  transition: box-shadow 0.3s ease-in-out;

  &:first-of-type {
    margin-top: 20px;
  }

  @media screen and (min-width: 768px) {
    margin: 20px;
  }

  ${({ isClickable }) =>
    isClickable &&
    css`
      &:hover {
        cursor: pointer;
        box-shadow: 0px 7px 13px rgba(6, 22, 33, 0.13),
          0px 26px 44px rgba(33, 49, 60, 0.12);
        transition: box-shadow 0.3s ease-in-out;
      }
    `}

  flex-direction: ${({ checked }) => {
    return checked ? "row" : "column"
  }};

  width: 100%;
  @media (min-width: 768px) {
    width: ${({ cardWidth }) => {
      return cardWidth + "px;"
    }};
    height: ${props => (props.grid ? "206px" : "auto")};
  }

  .checkIcon {
    margin-right: 20px;
    img {
      width: 24px;
      height: 24px;
      @media (min-width: 768px) {
        width: 36px;
        height: 36px;
      }
    }
  }

  .cardContent-flex {
    display: flex;
    flex-direction: column;
  }

  .cardContent {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: space-between;

    & p {
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    @media screen and (min-width: 768px) {
      display: grid;
      grid-template-rows: repeat(4, 1fr);
      grid-template-columns: 1fr;
      gap: 16px;
  
      & h3 {
        grid-row: span 1;
        align-self: flex-end;
      }
      & p {
        align-self: baseline;
        grid-row: span 2;
        margin: 0;
      }
      & span {
        grid-row: span 1;
      }
    }

    ${({ grid }) =>
      grid &&
      css`
        gap: 32px;

        & h4 {
          grid-row: span 3;
        }
      `}
  }

  ${({ border }) =>
    border &&
    `
    border: 1px solid #D5D4F9;
    border-radius: 8px;
    padding: 24px;
    box-sizing: border-box;
    p:first-child, h3:first-child {
      margin-top: 0px;
    }
    p:last-child {
      margin-bottom: 0px;
    }

    @media screen and (min-width: 768px) {
      padding: 32px;
    }
  `}
  ${({ background }) =>
    background &&
    `
    background: ${background}
  `}
`

const Card = ({
  card,
  cardWidth = 360,
  background,
  border,
  checked,
  grid = false,
}) => {
  return (
    <StyledCard
      cardWidth={cardWidth}
      background={background}
      border={border}
      checked={checked}
      isClickable={card.link}
      href={card.link}
      rel={card.link ? "noopener" : undefined}
      target={card.link ? "_blank" : undefined}
      as={card.link ? "a" : "div"}
      grid={grid}
    >
      {checked && (
        <div className="checkIcon">
          <img
            alt="check"
            src="https://webassets.mongodb.com/_com_assets/cms/checkmark-frwttwkjav.svg"
          />
        </div>
      )}
      {card.content ? card.content : card}
    </StyledCard>
  )
}

const StyledCardGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  direction: flex-row;
  justify-content: center;
  @media (min-width: 768px) {
    justify-content: start;
  }
  margin: -20px -20px;
`

const CardGrid = ({
  cards,
  border,
  cardWidth,
  background,
  checked,
  grid = false,
}) => {
  return (
    <StyledCardGrid>
      {cards.map((card, i) => {
        return (
          <Card
            key={`cardgrid__grid--${card.link}--${i}`}
            card={card}
            cardWidth={cardWidth}
            background={background}
            border={border}
            checked={checked}
            grid={grid}
          />
        )
      })}
    </StyledCardGrid>
  )
}

export default CardGrid
